import Vue from 'vue'
// import {
//     getSitesEditorModuleStateKey,
//     transformUrl,
//     // mapObj
//   } from '@/utils/util'
  const state = {
    // userId: '',
  }
  const mutations = {
    update(state, payload) {
      for (const key in payload) {
        Vue.set(state, key, payload[key])
      }
    },
  }
//   const actions = {

//   }
  export default {
    namespaced: true,
    state,
    // getters,
    // actions,
    mutations,
  }
